/* eslint-disable */

(function($) {

	$(document).ready(function() {

		// bail early if we can't read cookies
		if ( ! Cookies )
			return


		// @debug
		// console.log( 'nstg_userLanguagePreference: ' + Cookies.get( 'nstg_userLanguagePreference' ) )
		// console.log( 'pll_language: ' + Cookies.get( 'pll_language' ) ) // this seems to be about the content. e.g. a japanese page will return 'jp', an english page will return 'en' - does not necessarily have anything to do with a user preference


		/**
		 * this just matches the list of languages and codes found in the admin:
		 * https://nanostring.local/wp-admin/admin.php?page=mlang
		 *
		 * there is surely a way to set this up programmatically, perhaps i'll do that soon
		 */
		let locales2languages = {
			en_US : 'en',
			ja_JP : 'jp',
		}

		/**
		 * just some mess to get a subdomain-less domain for use with our cookie later.
		 *
		 * loops through locales, compares with the first component of the hostname
		 * to determine whether a subdomain should be removed or not
		 *
		 * (we're trying to get a hostname without language sub-subdomain, and in
		 * a way that does not require knowing the hostname, so that e.g.
		 *
		 * staging.nanostring.com and jp.staging.nanostring.com both yield 'staging.nanostring.com', or
		 * nanostring.local and jp.nanostring.local both yield 'nanostring.local'
		 */
		let hostname = location.hostname.split('.')

		for ( let [locale, language] of Object.entries( locales2languages ) )
			if ( hostname.indexOf( language ) === 0 )
				hostname.shift()

		hostname = hostname.join('.')


		/**
		 * data management & click handling for language switcher links
		 */
		let $language_selects = $('ul.utility-menu li.lang-item a')

		for ( let language_select of $language_selects ) {
			// convert lang attr to locale, e.g. 'ja-JP' to 'ja_JP'
			let locale = language_select.lang.replace( '-', '_' )

			// set language as defined in locales2languages
			language_select.dataset.language = locales2languages[ locale ]

			// when user selects language, store preference as cookie across subdomains
			language_select.addEventListener( 'click', function( event ) {
				// @debug
				// console.log( hostname )

				Cookies.set(
					'nstg_userLanguagePreference',
					event.currentTarget.dataset.language, {
						expires: 7,
						domain: '.' + hostname // .nanostring.local, or .staging.nanostring.com, etc.
					}
				)
			})
		}

	})

})( jQuery )
